/* eslint-disable react/react-in-jsx-scope */
import { Divider } from 'primereact/divider';
import { useDispatch, useSelector } from 'react-redux';

import locationIcon from '../../../assets/locationIcon.png';
import userAvatarOverlay from '../../../assets/userAvatarOverlay.png';
import { logToServer } from '../../../components/logger/logger';
import { UserInitialIcon } from '../../../components/userInitialIcon/UserInitialIcon';
import {
    logOut,
    selectCurrentEmpid,
    selectCurrentRole,
    selectCurrentUser, //selectCurrentUser,
    selectCurrentUserEmail,
    // selectCurrentUserFullName,
} from '../../../pages/login/authSlice';
import { persistor } from '../../../store/store';
import { PRODUCTION_APP_ENVIRONMENT } from '../../../constants';
import { useGetProfilePhotoQuery } from '../profilePhoto/profilePhotoSlice';

interface ProfileSectionProps {
    setVisibleAboutMe: (visible: boolean) => void;
    setVisibleSignUpNotification: (visible: boolean) => void;
    setVisibleApprovalCalendar: (visible: boolean) => void;
}

export const ProfileSection = ({
    setVisibleAboutMe,
    setVisibleSignUpNotification,
    setVisibleApprovalCalendar,
}: ProfileSectionProps) => {
    const dispatch = useDispatch();
    const empId = useSelector(selectCurrentEmpid);
    const loggedUser = useSelector(selectCurrentUser);
    const loggedUserEmail = useSelector(selectCurrentUserEmail);

    const { data: profilePhotoBase64 } = useGetProfilePhotoQuery(
        { email: loggedUserEmail },
        { skip: !loggedUserEmail, refetchOnMountOrArgChange: false }
    );
    const profilePhotoUrl = profilePhotoBase64 ? `data:image/jpeg;base64,${profilePhotoBase64}` : null;
    // const userFullName =useSelector(selectCurrentUserFullName);
    const role = useSelector(selectCurrentRole);

    const signOuthandler = (e: any) => {
        e.preventDefault();

        logToServer(empId, 'logout');

        setTimeout(() => {
            dispatch(logOut());
            localStorage.clear();
            persistor.purge();
        }, 200);

        // setTimeout(() => {
        //     // window.location.replace('https://identity.ttec.com/idp/startSLO.ping');
        //     window.location.replace(process.env.REACT_APP_END_SESSION_URI);
        // }, 700);

                setTimeout(() => {
            // window.location.replace('https://identity.ttec.com/idp/startSLO.ping');
            const endSessionUri = process.env.REACT_APP_END_SESSION_URI;
            if (endSessionUri) {
                window.location.replace(endSessionUri);
            } else {
                // Optionally handle the error, e.g., log or show a message
                console.error('REACT_APP_END_SESSION_URI is not defined');
            }
        }, 700);
    };

    const onAboutMeClicked = () => {
        setVisibleAboutMe(true);
    };

    const onSignUpNotificationClicked = () => {
        setVisibleSignUpNotification(true);
    };

    const onApprovalCalendarClicked = () => {
        setVisibleApprovalCalendar(true);
    };

    return (
        <>
            <div className="row">
                <div className="col-md-2">
                    <img
                        className="justify-content-left me-4"
                        src={profilePhotoUrl || userAvatarOverlay}
                        width={36}
                        height={36}
                        style={{ objectFit: 'cover', borderRadius: '50%' }}
                        alt="User"
                    />
                </div>
                <div className="col-md-10 ps-4">
                    <h6 style={{ fontSize: '14px', fontWeight: '800' }} className="mt-1 mb-0 text-capitalize">
                        {' '}
                        {loggedUser}
                    </h6>
                    {/* <p style={{ fontSize: '12px', fontWeight: '500' }} className="p-0 m-0">Customer Service Agent</p> */}
                    <p
                        style={{ fontSize: '13px' }}
                        className="p-0 m-0 text-muted align-bottom text-capitalize"
                    >
                        <img src={locationIcon} alt="location" className="pe-1 align-middle" /> {role}
                    </p>
                </div>
            </div>
            <Divider />
            {/* NOT PRODUCTION READY */}
            {process.env.REACT_APP_ENVIRONMENT !== PRODUCTION_APP_ENVIRONMENT && (
                <p style={{ fontSize: '14px', fontWeight: '500' }} className="mb-0 logOutItem">
                    <i className="languagePreference me-1 align-middle" /> Language Preference{' '}
                    <i className="downArrowIcon mt-2 me-1 align-bottom float-end" />
                </p>
            )}

            {/* NOT PRODUCTION READY */}
            {process.env.REACT_APP_ENVIRONMENT !== PRODUCTION_APP_ENVIRONMENT && (
                <p style={{ fontSize: '14px', fontWeight: '500' }} className="mb-0 logOutItem mt-3">
                    <i className="help me-1 align-middle" /> Help
                </p>
            )}
            
                <div // eslint-disable-line jsx-a11y/no-static-element-interactions
                    style={{ fontSize: '14px', fontWeight: '500', display: 'flex' }}
                    className="mb-0 logOutItem mt-3"
                    onClick={onApprovalCalendarClicked}
                    onKeyDown={onApprovalCalendarClicked}
                >
                    <i className="approvalCalendar me-1 align-middle" /> Approval Calendar
                </div>
                <div // eslint-disable-line jsx-a11y/no-static-element-interactions
                    style={{ fontSize: '14px', fontWeight: '500', display: 'flex' }}
                    className="mb-0 logOutItem mt-3"
                    onClick={onAboutMeClicked}
                    onKeyDown={onAboutMeClicked}
                >
                    <UserInitialIcon iHeight="20px" iWidth="20px" iFontSize="12px" user={loggedUser} />
                    <i className="me-1 align-middle" /> About Me
                </div>
                <div // eslint-disable-line jsx-a11y/no-static-element-interactions
                    style={{ fontSize: '14px', fontWeight: '500', display: 'none' }}
                    className="mb-0 logOutItem mt-3"
                    onClick={onSignUpNotificationClicked}
                    onKeyDown={onSignUpNotificationClicked}
                >
                    <p style={{ fontSize: '14px', fontWeight: '500' }} className="mb-0 logOutItem mt-3">
                        <i className="notificationBell me-1 align-middle" /> Notifications
                    </p>
                </div>

            <Divider />

            <p
                style={{ fontSize: '14px', fontWeight: '500' }}
                className="mb-0 logOutItem"
                onClick={signOuthandler}
                aria-hidden="true"
            >
                <i className="logout me-1 align-middle" /> Sign Out
            </p>
        </>
    );
};
